import React from 'react'
import About from './About';
import Work from './Work';
import Contact from './Contact';
import Header from './Header';

import spotify from '../images/SPOTIFY.png'
import amazon from '../images/AMAZON.png'
import ig from '../images/IG.png'
import mob from '../images/MOB.png'
import discord from '../images/discord.png'
import tiktok from '../images/TIKTOK.png'
import airbnb from '../images/airbnb.png'
import netflix from '../images/netflix.png'

const projects = [
  {
    name: airbnb,
    url: 'https://www.github.com/50vincents/airbnb-clone',
    demo: 'https://airbnb-clone-4dcd2.web.app/'
  },
  {
    name: netflix,
    url: 'https://www.github.com/50vincents/netflix-clone',
    demo: 'https://netflixclone-b0d72.web.app/'
  },
  {
    name: discord,
    url: 'https://www.github.com/50vincents/discord-clone',
    demo: 'https://discord-app-b3274.web.app/'
  }, 
  {
    name :spotify,
    url: 'https://www.github.com/50vincents/spotifyclone',
    demo: 'https://spotify-clone-c6427.web.app/'
  }, 
  {
    name: amazon,
    url: 'https://www.github.com/50vincents/amazon-clone',
    demo: 'https://clone-18e27.web.app/'
  }, 
  {
    name: ig,
    url: 'https://www.github.com/50vincents/instaclone',
    demo: 'https://instagram-clone-7564b.web.app/'
  }, 
  {
    name: tiktok,
    url: 'https://www.github.com/50vincents/tiktok-clone',
    demo: 'https://www.tiktok-clone-8780a.web.app'
  }, 
  {
    name: mob,
    url: 'https://www.github.com/jiyingqi/QuietPlace'
  },
]

function Body() {
  return (
    <div>
      <About />
      <Work projects={projects}/>
      <Contact />
    </div>
  )
}

export default Body
